import React from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TableCell,
  Button,
} from "@material-ui/core";
import DataTable from "src/components/DataTable";
import { Close } from "@material-ui/icons";
import moment from "moment";
import { makeStyles } from "@material-ui/styles";
import AssignStatusProgress from "../../progress/assignStatusProgress";

const useStyle = makeStyles((theme) => ({
  attributeText: {
    color: "#b2b2b2",
    fontSize: 12,
    whiteSpace: "break-spaces",
  },
}));

export default function ReassignHistoryDialogComponent({
  handleChangePage,
  filter,
  logs,
  isError,
  isFetching,
  total,
  handleClose,
  isOpen,
  handleChangeRowsPerPage,
  rowsPerPageOption,
  handleReload,
}) {
  const classes = useStyle();

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: "1rem",
          }}
        >
          <DialogTitle id="scroll-dialog-title">Reassign History</DialogTitle>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent
          dividers
          style={{ backgroundColor: "#f3f3f3", maxHeight: "70vh" }}
        >
          <Box>
            {isError ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
              >
                <Typography
                  variant="body2"
                  style={{ color: "#9CA6A9", paddingBottom: "16px" }}
                >
                  Something went wrong
                </Typography>
                <Button
                  variant="contained"
                  onClick={handleReload}
                  disableElevation
                >
                  REFRESH
                </Button>
              </Box>
            ) : (
              <DataTable
                isLoading={isFetching}
                rows={logs}
                rowsPerPage={filter.rowsPerPage}
                rowsPerPageOption={rowsPerPageOption}
                total={total}
                page={filter.page}
                renderHeader={() => (
                  <>
                    <TableCell>ID</TableCell>
                    <TableCell>Batch Number</TableCell>
                    <TableCell>Product</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Date Created</TableCell>
                  </>
                )}
                renderRow={(row, index) => (
                  <>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.batch_number}</TableCell>
                    <TableCell>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="flex-start"
                      >
                        <Typography variant="body2">
                          {row.product.name || "-"}
                        </Typography>
                        {!!row.product.attributes &&
                          !!row.product.attributes.length && (
                            <Typography
                              className={classes.attributeText}
                              variant="caption"
                            >
                              {row.product.attributes.join(", ")}
                            </Typography>
                          )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {row.quantity.toLocaleString("en-US")}
                    </TableCell>
                    <TableCell>
                      <AssignStatusProgress
                        assignUuid={row.uuid}
                        initialProgress={row.progress}
                        initialStatus={row.status}
                      />
                    </TableCell>
                    <TableCell>
                      {moment
                        .utc(row.created_at)
                        .local()
                        .format("DD MMM YYYY, HH:ss")}
                    </TableCell>
                  </>
                )}
                onPageClick={handleChangePage}
                handleItemPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
